import React from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Switch,
  Upload,
  Radio,
  Avatar,
} from 'antd';
import {
  SaveOutlined,
  CloseOutlined,
  UploadOutlined,
  BankOutlined,
  DollarOutlined,
} from '@ant-design/icons';

const { Option } = Select;

const ACCOUNT_TYPES = [
  { value: 'saving', label: 'پس‌انداز' },
  { value: 'current', label: 'جاری' },
  { value: 'credit-card', label: 'کارت اعتباری' },
  { value: 'loan', label: 'وام' },
  { value: 'overdraft', label: 'اضافه برداشت' },
];

const BankAccountForm = ({
  form,
  accountType,
  onAccountTypeChange,
  currencies = [],
  submitting = false,
  onSubmit,
  onCancel,
  isEdit = false,
  logoFile,
  onLogoUpload,
  currentLogo = null,
}) => (
  <Form
    form={form}
    layout="vertical"
    onFinish={onSubmit}
    scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
    initialValues={isEdit ? undefined : { type: 'bank', status: true, opening_balance: 0 }}
    className="custom-font"
  >
    <Form.Item
      name="type"
      label="نوع حساب"
      rules={[{ required: true, message: 'لطفاً نوع حساب را انتخاب کنید' }]}
    >
      <Radio.Group onChange={onAccountTypeChange} className="w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Radio.Button value="bank" className="h-24 flex items-center justify-center">
            <div className="text-center">
              <BankOutlined className="text-3xl mb-2 block" />
              <span>حساب بانکی</span>
            </div>
          </Radio.Button>
          <Radio.Button value="cash" className="h-24 flex items-center justify-center">
            <div className="text-center">
              <DollarOutlined className="text-3xl mb-2 block" />
              <span>صندوق نقدی</span>
            </div>
          </Radio.Button>
        </div>
      </Radio.Group>
    </Form.Item>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Form.Item
        name="account_name"
        label="نام حساب"
        rules={[{ required: true, message: 'لطفاً نام حساب را وارد کنید' }]}
      >
        <Input placeholder="نام صاحب حساب یا نام حساب" />
      </Form.Item>

      <Form.Item
        name="currency_id"
        label="واحد پول"
        rules={[{ required: true, message: 'لطفاً واحد پول را انتخاب کنید' }]}
      >
        <Select placeholder="انتخاب واحد پول">
          {currencies.map((cur) => (
            <Option key={cur.id} value={cur.id}>
              {cur.currency_symbol} ({cur.currency_code})
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>

    {accountType === 'bank' && (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Form.Item
            name="bank_name"
            label="نام بانک"
            rules={[{ required: true, message: 'لطفاً نام بانک را وارد کنید' }]}
          >
            <Input placeholder="مثال: صادرات، ملت، ..." />
          </Form.Item>

          <Form.Item name="account_number" label="شماره حساب / کارت">
            <Input placeholder="شماره حساب یا شماره کارت" />
          </Form.Item>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Form.Item name="account_type" label="نوع حساب بانکی">
            <Select placeholder="انتخاب نوع حساب">
              {ACCOUNT_TYPES.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="bank_logo" label="لوگوی بانک">
            <div className="flex items-center gap-4">
              {currentLogo && !currentLogo.includes('<i class=') && (
                <Avatar src={currentLogo} size={64} icon={<BankOutlined />} />
              )}
              <Upload
                beforeUpload={() => false}
                onChange={onLogoUpload}
                maxCount={1}
                accept="image/*"
                listType="picture"
                fileList={logoFile ? [{ uid: '-1', name: logoFile.name, status: 'done' }] : undefined}
              >
                <Button icon={<UploadOutlined />}>
                  {currentLogo ? 'تغییر تصویر' : 'انتخاب تصویر'}
                </Button>
              </Upload>
            </div>
          </Form.Item>
        </div>
      </>
    )}

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Form.Item name="contact_number" label="شماره تماس">
        <Input placeholder="شماره تماس مرتبط با حساب" />
      </Form.Item>

      <Form.Item name="opening_balance" label="موجودی اولیه">
        <InputNumber
          className="w-full"
          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={(value) => value.replace(/,/g, '')}
          placeholder="موجودی اولیه حساب"
        />
      </Form.Item>
    </div>

    <Form.Item name="status" label="وضعیت" valuePropName="checked">
      <Switch checkedChildren="فعال" unCheckedChildren="غیرفعال" />
    </Form.Item>

    <div className="flex justify-end gap-4 mt-6 pt-4 border-t border-gray-100 dark:border-gray-700">
      <Button icon={<CloseOutlined />} onClick={onCancel}>
        انصراف
      </Button>
      <Button
        type="primary"
        icon={<SaveOutlined />}
        htmlType="submit"
        loading={submitting}
        className="bg-green-600 hover:bg-green-700 border-green-600"
      >
        {isEdit ? 'ذخیره تغییرات' : 'ذخیره'}
      </Button>
    </div>
  </Form>
);

export default BankAccountForm;
